const $ = require("jquery");
const jQuery = require("jquery.easing");
const bodyScroll = require('body-scroll-toggle');
const fullpage = require("fullpage.js");
const Vivus = require("vivus");
const PhotoSwipe = require( 'photoswipe' );
const autosize = require( 'autosize' );


import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default'

import scrollSpy from 'simple-scrollspy'



autosize(document.querySelectorAll('textarea'));

/*!
 * parallax.js v1.5.0 (http://pixelcog.github.io/parallax.js/)
 * @copyright 2016 PixelCog, Inc.
 * @license MIT (https://github.com/pixelcog/parallax.js/blob/master/LICENSE)
 */

;(function ( $, window, document, undefined ) {

  // Polyfill for requestAnimationFrame
  // via: https://gist.github.com/paulirish/1579671

  (function() {
    var lastTime = 0;
    var vendors = ['ms', 'moz', 'webkit', 'o'];
    for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
      window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame'];
      window.cancelAnimationFrame = window[vendors[x]+'CancelAnimationFrame'] || window[vendors[x]+'CancelRequestAnimationFrame'];
    }

    if (!window.requestAnimationFrame)
      window.requestAnimationFrame = function(callback) {
        var currTime = new Date().getTime();
        var timeToCall = Math.max(0, 16 - (currTime - lastTime));
        var id = window.setTimeout(function() { callback(currTime + timeToCall); },
          timeToCall);
        lastTime = currTime + timeToCall;
        return id;
      };

    if (!window.cancelAnimationFrame)
      window.cancelAnimationFrame = function(id) {
        clearTimeout(id);
      };
  }());


  // Parallax Constructor

  function Parallax(element, options) {
    var self = this;

    if (typeof options == 'object') {
      delete options.refresh;
      delete options.render;
      $.extend(this, options);
    }

    this.$element = $(element);

    if (!this.imageSrc && this.$element.is('img')) {
      this.imageSrc = this.$element.attr('src');
    }

    var positions = (this.position + '').toLowerCase().match(/\S+/g) || [];

    if (positions.length < 1) {
      positions.push('center');
    }
    if (positions.length == 1) {
      positions.push(positions[0]);
    }

    if (positions[0] == 'top' || positions[0] == 'bottom' || positions[1] == 'left' || positions[1] == 'right') {
      positions = [positions[1], positions[0]];
    }

    if (this.positionX !== undefined) positions[0] = this.positionX.toLowerCase();
    if (this.positionY !== undefined) positions[1] = this.positionY.toLowerCase();

    self.positionX = positions[0];
    self.positionY = positions[1];

    if (this.positionX != 'left' && this.positionX != 'right') {
      if (isNaN(parseInt(this.positionX))) {
        this.positionX = 'center';
      } else {
        this.positionX = parseInt(this.positionX);
      }
    }

    if (this.positionY != 'top' && this.positionY != 'bottom') {
      if (isNaN(parseInt(this.positionY))) {
        this.positionY = 'center';
      } else {
        this.positionY = parseInt(this.positionY);
      }
    }

    this.position =
      this.positionX + (isNaN(this.positionX)? '' : 'px') + ' ' +
      this.positionY + (isNaN(this.positionY)? '' : 'px');

    if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
      if (this.imageSrc && this.iosFix && !this.$element.is('img')) {
        this.$element.css({
          backgroundImage: 'url("' + this.imageSrc + '")',
          backgroundSize: 'cover',
          backgroundPosition: this.position
        });
      }
      return this;
    }

    if (navigator.userAgent.match(/(Android)/)) {
      if (this.imageSrc && this.androidFix && !this.$element.is('img')) {
        this.$element.css({
          backgroundImage: 'url("' + this.imageSrc + '")',
          backgroundSize: 'cover',
          backgroundPosition: this.position
        });
      }
      return this;
    }

    this.$mirror = $('<div />').prependTo(this.mirrorContainer);

    var slider = this.$element.find('>.parallax-slider');
    var sliderExisted = false;

    if (slider.length == 0)
      this.$slider = $('<img />').prependTo(this.$mirror);
    else {
      this.$slider = slider.prependTo(this.$mirror)
      sliderExisted = true;
    }

    this.$mirror.addClass('parallax-mirror').css({
      visibility: 'hidden',
      zIndex: this.zIndex,
      position: 'fixed',
      top: 0,
      left: 0,
      overflow: 'hidden'
    });

    this.$slider.addClass('parallax-slider').one('load', function() {
      if (!self.naturalHeight || !self.naturalWidth) {
        self.naturalHeight = this.naturalHeight || this.height || 1;
        self.naturalWidth  = this.naturalWidth  || this.width  || 1;
      }
      self.aspectRatio = self.naturalWidth / self.naturalHeight;

      Parallax.isSetup || Parallax.setup();
      Parallax.sliders.push(self);
      Parallax.isFresh = false;
      Parallax.requestRender();
    });

    if (!sliderExisted)
      this.$slider[0].src = this.imageSrc;

    if (this.naturalHeight && this.naturalWidth || this.$slider[0].complete || slider.length > 0) {
      this.$slider.trigger('load');
    }

  }


  // Parallax Instance Methods

  $.extend(Parallax.prototype, {
    speed:    0.2,
    bleed:    0,
    zIndex:   -100,
    iosFix:   true,
    androidFix: true,
    position: 'center',
    overScrollFix: false,
    mirrorContainer: 'body',

    refresh: function() {
      this.boxWidth        = this.$element.outerWidth();
      this.boxHeight       = this.$element.outerHeight() + this.bleed * 2;
      this.boxOffsetTop    = this.$element.offset().top - this.bleed;
      this.boxOffsetLeft   = this.$element.offset().left;
      this.boxOffsetBottom = this.boxOffsetTop + this.boxHeight;

      var winHeight = Parallax.winHeight;
      var docHeight = Parallax.docHeight;
      var maxOffset = Math.min(this.boxOffsetTop, docHeight - winHeight);
      var minOffset = Math.max(this.boxOffsetTop + this.boxHeight - winHeight, 0);
      var imageHeightMin = this.boxHeight + (maxOffset - minOffset) * (1 - this.speed) | 0;
      var imageOffsetMin = (this.boxOffsetTop - maxOffset) * (1 - this.speed) | 0;
      var margin;

      if (imageHeightMin * this.aspectRatio >= this.boxWidth) {
        this.imageWidth    = imageHeightMin * this.aspectRatio | 0;
        this.imageHeight   = imageHeightMin;
        this.offsetBaseTop = imageOffsetMin;

        margin = this.imageWidth - this.boxWidth;

        if (this.positionX == 'left') {
          this.offsetLeft = 0;
        } else if (this.positionX == 'right') {
          this.offsetLeft = - margin;
        } else if (!isNaN(this.positionX)) {
          this.offsetLeft = Math.max(this.positionX, - margin);
        } else {
          this.offsetLeft = - margin / 2 | 0;
        }
      } else {
        this.imageWidth    = this.boxWidth;
        this.imageHeight   = this.boxWidth / this.aspectRatio | 0;
        this.offsetLeft    = 0;

        margin = this.imageHeight - imageHeightMin;

        if (this.positionY == 'top') {
          this.offsetBaseTop = imageOffsetMin;
        } else if (this.positionY == 'bottom') {
          this.offsetBaseTop = imageOffsetMin - margin;
        } else if (!isNaN(this.positionY)) {
          this.offsetBaseTop = imageOffsetMin + Math.max(this.positionY, - margin);
        } else {
          this.offsetBaseTop = imageOffsetMin - margin / 2 | 0;
        }
      }
    },

    render: function() {
      var scrollTop    = Parallax.scrollTop;
      var scrollLeft   = Parallax.scrollLeft;
      var overScroll   = this.overScrollFix ? Parallax.overScroll : 0;
      var scrollBottom = scrollTop + Parallax.winHeight;

      if (this.boxOffsetBottom > scrollTop && this.boxOffsetTop <= scrollBottom) {
        this.visibility = 'visible';
        this.mirrorTop = this.boxOffsetTop  - scrollTop;
        this.mirrorLeft = this.boxOffsetLeft - scrollLeft;
        this.offsetTop = this.offsetBaseTop - this.mirrorTop * (1 - this.speed);
      } else {
        this.visibility = 'hidden';
      }

      this.$mirror.css({
        transform: 'translate3d('+this.mirrorLeft+'px, '+(this.mirrorTop - overScroll)+'px, 0px)',
        visibility: this.visibility,
        height: this.boxHeight,
        width: this.boxWidth
      });

      this.$slider.css({
        transform: 'translate3d('+this.offsetLeft+'px, '+this.offsetTop+'px, 0px)',
        position: 'absolute',
        height: this.imageHeight,
        width: this.imageWidth,
        maxWidth: 'none'
      });
    }
  });


  // Parallax Static Methods

  $.extend(Parallax, {
    scrollTop:    0,
    scrollLeft:   0,
    winHeight:    0,
    winWidth:     0,
    docHeight:    1 << 30,
    docWidth:     1 << 30,
    sliders:      [],
    isReady:      false,
    isFresh:      false,
    isBusy:       false,

    setup: function() {
      if (this.isReady) return;

      var self = this;

      var $doc = $(document), $win = $(window);

      var loadDimensions = function() {
        Parallax.winHeight = $win.height();
        Parallax.winWidth  = $win.width();
        Parallax.docHeight = $doc.height();
        Parallax.docWidth  = $doc.width();
      };

      var loadScrollPosition = function() {
        var winScrollTop  = $win.scrollTop();
        var scrollTopMax  = Parallax.docHeight - Parallax.winHeight;
        var scrollLeftMax = Parallax.docWidth  - Parallax.winWidth;
        Parallax.scrollTop  = Math.max(0, Math.min(scrollTopMax,  winScrollTop));
        Parallax.scrollLeft = Math.max(0, Math.min(scrollLeftMax, $win.scrollLeft()));
        Parallax.overScroll = Math.max(winScrollTop - scrollTopMax, Math.min(winScrollTop, 0));
      };

      $win.on('resize.px.parallax load.px.parallax', function() {
          loadDimensions();
          self.refresh();
          Parallax.isFresh = false;
          Parallax.requestRender();
        })
        .on('scroll.px.parallax load.px.parallax', function() {
          loadScrollPosition();
          Parallax.requestRender();
        });

      loadDimensions();
      loadScrollPosition();

      this.isReady = true;

      var lastPosition = -1;

      function frameLoop() {
        if (lastPosition == window.pageYOffset) {   // Avoid overcalculations
          window.requestAnimationFrame(frameLoop);
          return false;
        } else lastPosition = window.pageYOffset;

        self.render();
        window.requestAnimationFrame(frameLoop);
      }

      frameLoop();
    },

    configure: function(options) {
      if (typeof options == 'object') {
        delete options.refresh;
        delete options.render;
        $.extend(this.prototype, options);
      }
    },

    refresh: function() {
      $.each(this.sliders, function(){ this.refresh(); });
      this.isFresh = true;
    },

    render: function() {
      this.isFresh || this.refresh();
      $.each(this.sliders, function(){ this.render(); });
    },

    requestRender: function() {
      var self = this;
      self.render();
      self.isBusy = false;
    },
    destroy: function(el){
      var i,
          parallaxElement = $(el).data('px.parallax');
      parallaxElement.$mirror.remove();
      for(i=0; i < this.sliders.length; i+=1){
        if(this.sliders[i] == parallaxElement){
          this.sliders.splice(i, 1);
        }
      }
      $(el).data('px.parallax', false);
      if(this.sliders.length === 0){
        $(window).off('scroll.px.parallax resize.px.parallax load.px.parallax');
        this.isReady = false;
        Parallax.isSetup = false;
      }
    }
  });


  // Parallax Plugin Definition

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this);
      var options = typeof option == 'object' && option;

      if (this == window || this == document || $this.is('body')) {
        Parallax.configure(options);
      }
      else if (!$this.data('px.parallax')) {
        options = $.extend({}, $this.data(), options);
        $this.data('px.parallax', new Parallax(this, options));
      }
      else if (typeof option == 'object')
      {
        $.extend($this.data('px.parallax'), options);
      }
      if (typeof option == 'string') {
        if(option == 'destroy'){
            Parallax.destroy(this);
        }else{
          Parallax[option]();
        }
      }
    });
  }

  var old = $.fn.parallax;

  $.fn.parallax             = Plugin;
  $.fn.parallax.Constructor = Parallax;


  // Parallax No Conflict

  $.fn.parallax.noConflict = function () {
    $.fn.parallax = old;
    return this;
  };


  // Parallax Data-API

  $( function () { 
    $('[data-parallax="scroll"]').parallax(); 
  });

}($, window, document));








if ($('#nav-coaching').length) {

const options = {
    sectionClass: '.scrollspy',     // Query selector to your sections
    menuActiveTarget: '.navmenu-item', // Query selector to your elements that will be added `active` class
    offset: 100                     // Menu item will active before scroll to a matched section 100px
}

// init:
scrollSpy(document.getElementById('nav-coaching'), options)




}





// var target = window.location.hash;


// if (target != '#learn-more') {
//    $('.side-menu').addClass('hidden');
// }


// $('#best-learn').click(function(event) {
//   event.preventDefault(); // prevents link to be redirected
//   var time = 1500; // time for slideup effect
//   var url = $(this).attr("href")


//   $('.reasonone-description').addClass('hideup');
//   $('#fp-nav ul').addClass('hidefp');
//   $('.side-menu').removeClass('hidden');
  


//   setTimeout(function () {
//     $('.side-menu').addClass('sideexpand2');
//   }, 150);
//   setTimeout(function () {
//     $('.reasonone-image').addClass('hideup');
//   }, 150);
//   setTimeout(function () {
//     $('.over-color').addClass('over-height');

//   }, 800);

//   window.setTimeout(function(){document.location.href=url;}, time); // timeout and waiting until effect is complete
//   return -1;

  
 
// });



// $('.side-menu').click(function(event) {
//   event.preventDefault(); // prevents link to be redirected
//   var time = 400; // time for slideup effect
//   var url = $(this).attr("href")


//   $('#world-video-full').parent().fadeOut(300);


//   window.setTimeout(function(){document.location.href=url;}, time); // timeout and waiting until effect is complete
//   return -1;


// });


$('#mobile-nav a.hasDropdown').click(function(event) {
  event.preventDefault(); // prevents link to be redirected
   
  if (!$(this).hasClass('active')) {
    $(this).addClass('active');
    $('.subMenu').slideDown();
  } else {
    $(this).removeClass('active');
    $('.subMenu').slideUp();
  }
  


});



// const cycle = require('jquery.cycle2');

// Checkboxes animation

$( window ).on("load", function() {



if ($('#history').length) {
setTimeout(function () {
      // Figure out element to scroll to
      var target = window.location.hash;
      target = target.length ? $('[name=' + window.location.hash.substring(1) + ']') : $('[name=' + window.location.hash.substring(1) + ']');
      
        $('html, body').animate({
          scrollTop: target.offset().top - 120
        }, 600, function() { 
          // Callback after animation
          // Must change focus!
          var $target = $(target);
      
        });

}, 0);
}


var countL = -1;
var countR = -1;


checkScenario1();

function checkScenario1() {

  setTimeout(function () {
    $('#checkright-1').addClass('animated');
  }, 1000);

  setTimeout(function () {
    $('#checkleft-2').addClass('animated');
  }, 1300);

  setTimeout(function () {
    $('#checkright-3').addClass('animated');
  }, 1600);

  setTimeout(function () {
    $('#checkright-4').addClass('animated');
  }, 1900);
  
  setTimeout(function () {
    $('#checkright-5').addClass('animated');
  }, 2200);

  setTimeout(function () {
    $('#checkright-6').addClass('animated');
  }, 2500);

  setTimeout(function () {
    $('#checkright-7').addClass('animated');
  }, 2800);

  setTimeout(function () {
    $('#checkleft-8').addClass('animated');
  }, 3100);

  setTimeout(function () {
    $('.check-animation').removeClass('animated');
    checkScenario2();
  }, 5100);

}

function checkScenario2() {

  setTimeout(function () {
    $('#checkleft-1').addClass('animated');
  }, 1000);

  setTimeout(function () {
    $('#checkleft-2').addClass('animated');
  }, 1300);

  setTimeout(function () {
    $('#checkright-3').addClass('animated');
  }, 1600);

  setTimeout(function () {
    $('#checkright-4').addClass('animated');
  }, 1900);
  
  setTimeout(function () {
    $('#checkleft-5').addClass('animated');
  }, 2200);

  setTimeout(function () {
    $('#checkleft-6').addClass('animated');
  }, 2500);

  setTimeout(function () {
    $('#checkleft-7').addClass('animated');
  }, 2800);

  setTimeout(function () {
    $('#checkright-8').addClass('animated');
  }, 3100);

  setTimeout(function () {
    $('.check-animation').removeClass('animated');
    checkScenario3();
  }, 5100);

}

function checkScenario3() {

  setTimeout(function () {
    $('#checkright-1').addClass('animated');
  }, 1000);

  setTimeout(function () {
    $('#checkright-2').addClass('animated');
  }, 1300);

  setTimeout(function () {
    $('#checkright-3').addClass('animated');
  }, 1600);

  setTimeout(function () {
    $('#checkright-4').addClass('animated');
  }, 1900);
  
  setTimeout(function () {
    $('#checkleft-5').addClass('animated');
  }, 2200);

  setTimeout(function () {
    $('#checkleft-6').addClass('animated');
  }, 2500);

  setTimeout(function () {
    $('#checkright-7').addClass('animated');
  }, 2800);

  setTimeout(function () {
    $('#checkright-8').addClass('animated');
  }, 3100);

  setTimeout(function () {
    $('.check-animation').removeClass('animated');
    checkScenario1();
  }, 5100);

}





// setInterval(CheckLeftAnimation, 1000);
// setInterval(CheckRightAnimation, 1000);












});




if ($('#history').length) {

$('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
      && 
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top - 120
        }, 600, function() { 
          // Callback after animation
          // Must change focus!
          var $target = $(target);
      
        });
      }
    }
  });

} else {


$('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
      && 
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 600, function() { 
          // Callback after animation
          // Must change focus!
          var $target = $(target);
        
        });
      }
    }
  });


}



//scrollSpy function
     









import ScrollReveal from 'scrollreveal'


ScrollReveal().reveal('.reveal-section h2, .reveal-section h3, .reveal-section p, .reveal-section ul, .reveal-section img', { 

  duration: 1000,
  distance: '50px',

});


ScrollReveal().reveal('.revealnew', { 

	duration: 1000,
	distance: '50px',
	interval: 100,

});

ScrollReveal().reveal('.revealnew2', { 

	duration: 1000,
	distance: '50px',

});

ScrollReveal().reveal('.revealnew3', { 
	delay: 400,
	duration: 1000,
	distance: '50px',

});

ScrollReveal().reveal('.revealnew4', { 
	duration: 1000,
	distance: '50px',
	interval: 100,

});

ScrollReveal().reveal('.revealnew5', { 
	delay: 400,
	duration: 1000,
	distance: '50px',
	viewOffset: {
        bottom: -2000
    }
});

// !function(a){"use strict";a(document).on("cycle-bootstrap",function(a,b,c){"carousel"===b.fx&&(c.getSlideIndex=function(a){var b=this.opts()._carouselWrap.children(),c=b.index(a);return c%b.length},c.next=function(){var a=b.reverse?-1:1;b.allowWrap===!1&&b.currSlide+a>b.slideCount-b.carouselVisible||(b.API.advanceSlide(a),b.API.trigger("cycle-next",[b]).log("cycle-next"))})}),a.fn.cycle.transitions.carousel={preInit:function(b){b.fadeOutNonActive=!1,b.container.on("cycle-destroyed",a.proxy(this.onDestroy,b.API)),b.API.stopTransition=this.stopTransition;for(var c=0;c<b.startingSlide;c++)b.container.append(b.slides[0])},postInit:function(b){var c,d,e,f,g=b.carouselVertical;b.carouselVisible&&b.carouselVisible>b.slideCount&&(b.carouselVisible=b.slideCount-1);var h=b.carouselVisible||b.slides.length,i={display:g?"block":"inline-block",position:"static"};if(b.container.css({position:"relative",overflow:"hidden"}),b.slides.css(i),b._currSlide=b.currSlide,f=a('<div class="cycle-carousel-wrap"></div>').prependTo(b.container).css({margin:0,padding:0,top:0,left:0,position:"absolute"}).append(b.slides),b._carouselWrap=f,g||f.css("white-space","nowrap"),b.allowWrap!==!1){for(d=0;d<(void 0===b.carouselVisible?2:1);d++){for(c=0;c<b.slideCount;c++)f.append(b.slides[c].cloneNode(!0));for(c=b.slideCount;c--;)f.prepend(b.slides[c].cloneNode(!0))}f.find(".cycle-slide-active").removeClass("cycle-slide-active"),b.slides.eq(b.startingSlide).addClass("cycle-slide-active")}b.pager&&b.allowWrap===!1&&(e=b.slideCount-h,a(b.pager).children().filter(":gt("+e+")").hide()),b._nextBoundry=b.slideCount-b.carouselVisible,this.prepareDimensions(b)},prepareDimensions:function(b){var c,d,e,f,g=b.carouselVertical,h=b.carouselVisible||b.slides.length;if(b.carouselFluid&&b.carouselVisible?b._carouselResizeThrottle||this.fluidSlides(b):b.carouselVisible&&b.carouselSlideDimension?(c=h*b.carouselSlideDimension,b.container[g?"height":"width"](c)):b.carouselVisible&&(c=h*a(b.slides[0])[g?"outerHeight":"outerWidth"](!0),b.container[g?"height":"width"](c)),d=b.carouselOffset||0,b.allowWrap!==!1)if(b.carouselSlideDimension)d-=(b.slideCount+b.currSlide)*b.carouselSlideDimension;else for(e=b._carouselWrap.children(),f=0;f<b.slideCount+b.currSlide;f++)d-=a(e[f])[g?"outerHeight":"outerWidth"](!0);b._carouselWrap.css(g?"top":"left",d)},fluidSlides:function(b){function c(){clearTimeout(e),e=setTimeout(d,20)}function d(){b._carouselWrap.stop(!1,!0);var a=b.container.width()/b.carouselVisible;a=Math.ceil(a-g),b._carouselWrap.children().width(a),b._sentinel&&b._sentinel.width(a),h(b)}var e,f=b.slides.eq(0),g=f.outerWidth()-f.width(),h=this.prepareDimensions;a(window).on("resize",c),b._carouselResizeThrottle=c,d()},transition:function(b,c,d,e,f){var g,h={},i=b.nextSlide-b.currSlide,j=b.carouselVertical,k=b.speed;if(b.allowWrap===!1){e=i>0;var l=b._currSlide,m=b.slideCount-b.carouselVisible;i>0&&b.nextSlide>m&&l==m?i=0:i>0&&b.nextSlide>m?i=b.nextSlide-l-(b.nextSlide-m):0>i&&b.currSlide>m&&b.nextSlide>m?i=0:0>i&&b.currSlide>m?i+=b.currSlide-m:l=b.currSlide,g=this.getScroll(b,j,l,i),b.API.opts()._currSlide=b.nextSlide>m?m:b.nextSlide}else e&&0===b.nextSlide?(g=this.getDim(b,b.currSlide,j),f=this.genCallback(b,e,j,f)):e||b.nextSlide!=b.slideCount-1?g=this.getScroll(b,j,b.currSlide,i):(g=this.getDim(b,b.currSlide,j),f=this.genCallback(b,e,j,f));h[j?"top":"left"]=e?"-="+g:"+="+g,b.throttleSpeed&&(k=g/a(b.slides[0])[j?"height":"width"]()*b.speed),b._carouselWrap.animate(h,k,b.easing,f)},getDim:function(b,c,d){var e=a(b.slides[c]);return e[d?"outerHeight":"outerWidth"](!0)},getScroll:function(a,b,c,d){var e,f=0;if(d>0)for(e=c;c+d>e;e++)f+=this.getDim(a,e,b);else for(e=c;e>c+d;e--)f+=this.getDim(a,e,b);return f},genCallback:function(b,c,d,e){return function(){var c=a(b.slides[b.nextSlide]).position(),f=0-c[d?"top":"left"]+(b.carouselOffset||0);b._carouselWrap.css(b.carouselVertical?"top":"left",f),e()}},stopTransition:function(){var a=this.opts();a.slides.stop(!1,!0),a._carouselWrap.stop(!1,!0)},onDestroy:function(){var b=this.opts();b._carouselResizeThrottle&&a(window).off("resize",b._carouselResizeThrottle),b.slides.prependTo(b.container),b._carouselWrap.remove()}}}($)







var openPhotoSwipe = function(index) {
    var pswpElement = document.querySelectorAll('.pswp')[0];

    // build items array
    var items = [
        {
		html: "<div class='member-slide scrollable overflow-scroll'><img src='/img/about/team/tim-morin-f2.jpg'><h2 class='font-crimson text-3xl leading-none mt-4 mb-3'>Tim Morin</h2><p class='italic tracking-wide text-sm sm:text-lg leading-snug'>President & CEO</p><div class='text-justify block mt-10 px-5 sm:px-10'><p class='my-6'>As CEO since 2004, Tim Morin has long championed WJM’s culture of curiosity, learning and determined customer service. WJM’s clients benefit from Tim’s depth of insight into organizational and individual behavioral issues. Our Faculty members appreciate that he takes partnerships with coaches as seriously as with customers. Tim is a frequent writer on subjects around leadership development, behavior change, neuroscience and technology supporting coaching.</p><p class='my-6'>Tim joined the WJM team in 2001 after a successful investment banking career managing private and public equity offerings for media and technology companies. He received a BA in economics from Trinity College in Hartford, Conn. and an MBA from New York University’s Stern School of Business.</p><p class='my-6'>Tim lives with his wife and two children in Brooklyn Heights, NY.</p></div></div>"
	},
        {
        html: "<div class='member-slide scrollable overflow-scroll'><img src='/img/about/team/steve-galli-f2.jpg'><h2 class='font-crimson text-3xl leading-none mt-4 mb-3'>Steve Galli</h2><p class='italic tracking-wide text-sm sm:text-lg leading-snug'>Vice Chairman</p><div class='text-justify block mt-10 px-5 sm:px-10'><p class='my-6'>Steve Galli is currently a partner at Nisivoccia Wealth Advisors, a wealth management firm serving individuals and small businesses.  He became a primary shareholder of WJM in 2016 and is a passionate advocate of executive coaching.  As an angel investor focused on the technology sector, he has firsthand experience observing the impact that effective leadership has on business performance.</p><p class='my-6'>Steve began his finance career at the investment bank Solomon Brothers, joining their MBA Associate program when he completed his Masters in Finance at New York University’s Stern School of Business in 1997.  His over 25 years of diverse experience in the financial services industry includes positions at S&P Global, Morgan Stanley Capital International, Citigroup and Merrill Lynch where he worked in both New York City and Hong Kong.  He received his BA from Colgate University in Hamilton, NY.</p><p class='my-6'>Steve lives with his wife and two children in Demarest, NJ.</p></div></div>"
        },
        {
        html: "<div class='member-slide scrollable overflow-scroll'><img src='/img/about/team/alison-eydenberg-f2.jpg'><h2 class='font-crimson text-3xl leading-none mt-4 mb-3'>Alison Eydenberg</h2><p class='italic tracking-wide text-sm sm:text-lg leading-snug'>Head, Coaching Services</p><div class='text-justify block mt-10 px-5 sm:px-10'><p class='my-6'>Alison has been part of the WJM family since 2003. Presently as Head, Coaching Services, Alison serves as WJM’s “quality control officer” ensuring seamless delivery of coaching with integrity and accountability.  She and her team curate timely updates on engagements in WJM’s OneView platform and host group calls with WJM coaches delivering in the same customer organization to exchange learnings and context.  Finally, as a valued partner and adviser, Alison assists WJM Faculty members in gaining new perspectives and becoming more self-aware in their coaching practices.</p><p class='my-6'>Alison has a Masters Degree in Organizational Psychology from Columbia University and BA in Psychology from Denison University.  She is also a certified Coach Supervisor.</p><p class='my-6'>Alison lives in Massachusetts with her husband, daughter and corgi.</p></div></div>"
        },
        {
        html: "<div class='member-slide scrollable overflow-scroll'><img src='/img/about/team/scott-gingold-f2.jpg'><h2 class='font-crimson text-3xl leading-none mt-4 mb-3'>Scott Gingold</h2><p class='italic tracking-wide text-sm sm:text-lg leading-snug'>Senior Enterprise Partner</p><div class='text-justify block mt-10 px-5 sm:px-10'><p class='my-6'>As an Enterprise Partner at WJM, Scott Gingold combines an uncompromising commitment to customer service with a sweeping knowledge of coaching theory, research and practice. A continuous learner, Scott’s clients appreciate his contagious enthusiasm as a thinking partner.</p><p class='my-6'>Scott joined WJM in 2011 after many successful years with a global talent and career management firm, where he provided consulting support to Fortune 100 and mid-size companies across a wide range of industries.  He earned a BA in History from Cornell University, and an MA in Organizational Behavior from Fairleigh Dickinson University. Scott is a graduate of the Columbia University Coaching Certification Program (3CP), focused on executive and organizational coaching.</p><p class='my-6'>Scott is a volunteer career coach with the New Start Career Network, and he lives with his wife and twin sons in Northern New Jersey.</p></div></div>"
        },
        {
        html: "<div class='member-slide scrollable overflow-scroll'><img src='/img/about/team/scott-litchfield-f2.jpg'><h2 class='font-crimson text-3xl leading-none mt-4 mb-3'>Scott Litchfield</h2><p class='italic tracking-wide text-sm sm:text-lg leading-snug'>Senior Enterprise Partner</p><div class='text-justify block mt-10 px-5 sm:px-10'><p class='my-6'>With over 25 years of consultative client management experience and a passion for developing leaders, Scott Litchfield has made a career of supporting the success of others. He excels at building authentic partnerships based on mutual trust and understanding through his genuine and approachable style. Originally joining the WJM team in 2004, Scott has also served as Executive Director, Client Solutions at BlessingWhite and Director of Client Solutions for Korn Ferry. Today, in addition to his client management responsibilities, Scott oversees WJM’s business development efforts.</p><p class='my-6'>Scott earned a BA from Gettysburg College and an MBA from Long Island University. He lives in Harrington Park, NJ with his wife and two children.  He volunteers his time to his church, and enjoys running, cycling, and reading.</p></div></div>"
        },
        {
        html: "<div class='member-slide scrollable overflow-scroll'><img src='/img/about/team/whitney-siavelis-f2.jpg'><h2 class='font-crimson text-3xl leading-none mt-4 mb-3'>Whitney Siavelis</h2><p class='italic tracking-wide text-sm sm:text-lg leading-snug'>Senior Enterprise Partner</p><div class='text-justify block mt-10 px-5 sm:px-10'><p class='my-6'>Whitney Siavelis is passionate about helping companies and individuals maximize their success and brings 20 years of leadership experience in companies ranging from Fortune 100 to early-stage startups. She holds certification from the ICF, has been featured on CNBC and $mart Women Podcast, and has coached and developed hundreds of leaders from the world’s top companies. Drawing on this extensive background, Whitney works closely with WJM clients to tailor solutions that best meet their needs.</p><p class='my-6'>Whitney earned a BS from Kansas State University. A devoted philanthropist, she serves in mentor and advisory positions with various women’s and children’s organizations including AWARE, The Child HELP Partnership, Bloomberg Women’s Community, and Cornelia Connelly Center.</p><p class='my-6'>In her free time, Whitney enjoys watching documentary films, exploring new restaurants, and honing her stand-up comedy chops in NYC, her favorite city.</p></div></div>"
        },
        {
        html: "<div class='member-slide scrollable overflow-scroll'><img src='/img/about/team/helen-materazzi-f2.jpg'><h2 class='font-crimson text-3xl leading-none mt-4 mb-3'>Helen Materazzi</h2><p class='italic tracking-wide text-sm sm:text-lg leading-snug'>Senior Director, Leadership&nbsp;Development</p><div class='text-justify block mt-10 px-5 sm:px-10'><p class='my-6'>Helen Materazzi has over 25 years of experience in global talent management, executive development and organization effectiveness. Having held senior HR roles in global organizations, she understands the challenges business leaders face and rapidly uncovers ways to turn inertia into action. Adept at diagnosing complex organizational needs, Helen designs and delivers practical solutions that incorporate best practices and cover a wide range of business operational and functional areas.</p><p class='my-6'>She is a magna cum laude graduate of Rider University and studied at the University of Graz, Austria. She is proficient in German.  Helen lives on the Jersey shore with her husband, son, 100-lb. chocolate Labrador Retriever and feisty African Grey parrot.</p></div></div>"
        },
        {
        html: "<div class='member-slide scrollable overflow-scroll'><img src='/img/about/team/steve-salee-f2.jpg'><h2 class='font-crimson text-3xl leading-none mt-4 mb-3'>Steve Salee</h2><p class='italic tracking-wide text-sm sm:text-lg leading-snug'>Healthcare Advisor, WJM&nbsp;Healthcare</p><div class='text-justify block mt-10 px-5 sm:px-10'><p class='my-6'>Steve Salee is thrilled to be advising WJM on developing leaders in the healthcare industry. He has over 20 years of experience as a coach, organizational consultant, and strategist, and is particularly passionate about helping healthcare teams and leaders to work well together in service of quality patient care and outcomes.</p><p class='my-6'>Steve is an adjunct lecturer at the Columbia University School of Social Work. He has Masters Degrees in Social Work and Public Administration from Columbia University and graduated from Brown University with a BA in Urban Studies.</p><p class='my-6'>Steve rows on the Harlem River and will use any excuse to sing. He lives in New York with his partner, daughter, two sons and a dog named Charles.</p></div></div>"
        },
        {
        html: "<div class='member-slide scrollable overflow-scroll'><img src='/img/about/team/beth-edwards-f2.jpg'><h2 class='font-crimson text-3xl leading-none mt-4 mb-3'>Beth Edwards</h2><p class='italic tracking-wide text-sm sm:text-lg leading-snug'>Program Coordinator</p><div class='text-justify block mt-10 px-5 sm:px-10'><p class='my-6'>Beth Edwards provides project management for WJM’s leadership development engagements, ensuring an exceptional level of service for both our executive clients and our coaches. After a career as a performing artist at several dance companies, Beth brings an artistic edge and an exacting standard to her work.</p><p class='my-6'>Prior to joining WJM she was part of the accounting team at a prestigious NYC private school where she managed business matters while teaching dance to middle school students. She has also enjoyed her role as a mentor to scholarship students in the dance program at 92nd Street Y in New York. Beth holds a BFA in Dance and a Certificate in Arts Management from SUNY Purchase.</p><p class='my-6'>Beth lives in Nyack, NY with her husband and three children.</p></div></div>"
        }
    ];



    $('.pswp__container').on('wheel mousewheel DOMMouseScroll', '.scrollable', function(e) {
        // Stop the event propagation bubbling up to the existing photoswipe listener.
        e.stopPropagation();
    });
    
    // define options (if needed)
    var options = {
			 // history & focus options are disabled on CodePen
      	history: false,
      	focus: true,
      	closeOnScroll: false,
      	closeOnVerticalDrag: false,
      	shareEl: false,
      	counterEl: false,
      	zoomEl:false,
      	captionEl: false,
		fullscreenEl: false,
		timeToIdle: 60000000,
		timeToIdleOutside: 60000000,
		showHideOpacity:true,
		tapToToggleControls: false,
		closeElClasses: ['top-bar'],

        showAnimationDuration: 0,
        hideAnimationDuration: 0
        
    };
    
    var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
    

    gallery.init();

	gallery.goTo(index);

	bodyScroll.disable();


	gallery.listen('close', function() {
		
		$('body').removeClass('locked');

		bodyScroll.enable();

		
	});

};

// openPhotoSwipe();

$('.team-member').on('click', function (e) {
	var index = ($(this).data('member')) - 1;
	openPhotoSwipe(index);
});




// Coach click

$('.coach-learn').on('click', function (e) {
  e.preventDefault();
  if ($(this).text() != "Show Less" ) {
    $(this).prev().removeClass("hidden");
    $(this).text("Show Less");
  } else {
    $(this).prev().addClass("hidden");
    $(this).text("Learn More");
  }
  
});










document.addEventListener("DOMContentLoaded",function() {


let num = 20;
let num2 = 2600;
var light = 0;



$(window).bind('scroll', function() {
  if ($(window).scrollTop() > num2 ) {
    $('#nav-coaching span').addClass('activated');
  } else {
    $('#nav-coaching span').removeClass('activated');
  }


  if ($(window).scrollTop() > num || $('body').css('position') == 'fixed') {
    if ($('body').attr("id") != 'homepage') {
		$('#menu').addClass('inner');
	}
	if ($('#top-nav').hasClass('light')) {
		$('#top-nav,#hamburger').removeClass('light');
		$('#logo-dark').removeClass('opacity-0');
		$('#logo-light').addClass('opacity-0');
		light = 1;
		console.log(light)
	}
  }
  else {
    if ($('body').attr("id") != 'homepage') {
		$('#menu').removeClass('inner');	
	}

	console.log(light)
	if (light == 1) {
		$('#top-nav,#hamburger').addClass('light');
		$('#logo-dark').addClass('opacity-0');
		$('#logo-light').removeClass('opacity-0');
		light = 0;
	}

  }
});



// Dropdown submenu

$('#top-nav > a:first-child').on('mouseover', function (e) {
  $('.menu-dropdown').stop(true).slideDown();
  $('.insight-dropdown').stop(true).slideUp();
  $('.coaching-dropdown').stop(true).slideUp();
});



$('#menu, .menu-dropdown').on('mouseleave', function (e) {
  $('.menu-dropdown').stop(true).slideUp();
});



$('#top-nav > a:nth-child(2)').on('mouseover', function (e) {
  $('.coaching-dropdown').stop(true).slideDown();
  $('.menu-dropdown').stop(true).slideUp();
  $('.insight-dropdown').stop(true).slideUp();
});



$('#menu, .coaching-dropdown').on('mouseleave', function (e) {
  $('.coaching-dropdown').stop(true).slideUp();
});



$('#top-nav > a:nth-child(3)').on('mouseover', function (e) {
  $('.insight-dropdown').stop(true).slideDown();
  $('.menu-dropdown').stop(true).slideUp();
  $('.coaching-dropdown').stop(true).slideUp();
});



$('#menu, .insight-dropdown').on('mouseleave', function (e) {
  $('.insight-dropdown').stop(true).slideUp();
});


$('#top-nav > a').not('#top-nav > a:first-child, #top-nav > a:nth-child(2), #top-nav > a:nth-child(3)').on('mouseover', function (e) {
  $('.menu-dropdown').stop(true).slideUp();
  $('.coaching-dropdown').stop(true).slideUp();
  $('.insight-dropdown').stop(true).slideUp();
});




// hamburger menu

$('#hamburger').on('click', function (e) {
	$('#mobile-menu').toggleClass('hidden');
});

$('#hamburger-close').on('click', function (e) {
	$('#mobile-menu').toggleClass('hidden');
});


// footer contact forms

$('#coach-form').on('click', function (e) {
  $('#find-coach').removeClass('hidden');
});

$('#request-form').on('click', function (e) {
  $('#request-conversation').removeClass('hidden');
});

$('.close-newlightbox').on('click', function (e) {
  $('#find-coach').removeClass('hidden');
  $('#request-conversation').removeClass('hidden');
  $('#find-coach').addClass('hidden');
  $('#request-conversation').addClass('hidden');
});



	$("#home-clouds").addClass('animated');

	if ($('body').attr("id") == 'homepage') {

    // var url1 = '#reasonOne';
    // var url2 = '#reasonTwo';
    // var url3 = '#reasonThree';
    // var url4 = '#reasonFour';
    // var url5 = '#reasonFive';
    // var url6 = '#reasonSix';
    // var url7 = '#reasonSeven';

    // $('.menu-dropdown a:nth-child(1)').attr('href', url1)
    // $('.menu-dropdown a:nth-child(2)').attr('href', url2)
    // $('.menu-dropdown a:nth-child(3)').attr('href', url3)
    // $('.menu-dropdown a:nth-child(4)').attr('href', url4)
    // $('.menu-dropdown a:nth-child(5)').attr('href', url5)
    // $('.menu-dropdown a:nth-child(6)').attr('href', url6)
    // $('.menu-dropdown a:nth-child(7)').attr('href', url7)
    


	setTimeout(function(){
		$("#top-nav > a:first-child").addClass('active');

		$("#home-lady").addClass('animated');
	}, 1000);

	} else if ($('body').attr("id") == 'coach-supervision') {
		$("#top-nav a:nth(0)").addClass('active');


    } else if ($('body').attr("id") == 'executiveCoaching') {
        $("#top-nav a:nth(1)").addClass('active');

	} else if ($('body').attr("id") == 'insight' || $('body').attr("id") == 'executive-coaching-qa'  || $('body').attr("id") == 'what-we-are-reading' ) {
		$("#top-nav a:nth(2)").addClass('active');

	} else if ($('body').attr("id") == 'about') {
		$("#top-nav a:nth(3)").addClass('active');

	} else if ($('body').attr("id") == 'customers') {
		$("#top-nav a:nth(4)").addClass('active');
  } else if ($('body').attr("id") == 'contact') {
    $("#top-nav a:nth(5)").addClass('active');
  }





	$('.fp-tooltip').on( "click", function() {
		fullpage_api.moveTo($(this).parent().find('a').attr('href').substring(1), 1);
	});


	// $('.customers-slider1').cycle({
	// 	fx: "carousel",
	// 	slides: "> div",
	// 	timeout: 2000,
	// 	speed: 1000,
	// 	random: true,
	// 	carouselVertical: true,
	// 	carouselVisible: 3,
	// 	captionPlugin: "caption2",
	// 	easing: "easeInOutCubic",
	// 	overlayFxSel: "div"
	// });

	// $('.customers-slider2').cycle({
	// 	fx: "carousel",
	// 	slides: "> div",
	// 	timeout: 2000,
	// 	speed: 1000,
	// 	random: true,
	// 	reverse: true,
	// 	carouselVertical: true,
	// 	carouselVisible: 2,
	// 	captionPlugin: "caption2",
	// 	easing: "easeInOutCubic",
	// 	overlayFxSel: "div"
	// });


});



let homeClouds = new Vivus('home-clouds', {
  file: '/img/fullpage/home-clouds-gator.svg',
  type: 'delayed',
  start: 'manual',
  duration: 100,
  animTimingFunction: Vivus.EASE,
  onReady: function (myVivus) {
    // `el` property is the SVG element
    // myVivus.el.setAttribute('height', 'auto');
    homeClouds.play()
  }
});


let reasonOneStage1 = new Vivus('reasonOne-stage1', {
  file: '/img/fullpage/reasonOne-nostars.svg',
  type: 'delayed',
  start: 'manual',
  duration: 100,
  animTimingFunction: Vivus.EASE,
  onReady: function (reasonOneStage1) {
    // `el` property is the SVG element
    // myVivus.el.setAttribute('height', 'auto');
    
  }
});


let reasonTwoStage1 = new Vivus('reasonTwo-stage1', {
  file: '/img/fullpage/reasonTwo-gator.svg',
  type: 'delayed',
  start: 'manual',
  duration: 100,
  animTimingFunction: Vivus.EASE,
  onReady: function (reasonTwoStage1) {
    // `el` property is the SVG element
    // myVivus.el.setAttribute('height', 'auto');
    
  }
});


let reasonFourStage1 = new Vivus('reasonFour-stage1', {
  file: '/img/fullpage/reasonFour.svg',
  type: 'delayed',
  start: 'manual',
  duration: 100,
  animTimingFunction: Vivus.EASE,
  onReady: function (reasonFourStage1) {
    // `el` property is the SVG element
    // myVivus.el.setAttribute('height', 'auto');
    
  }
});


let reasonFiveStage1 = new Vivus('reasonFive-stage1', {
  file: '/img/fullpage/reasonFive-gator.svg',
  type: 'delayed',
  start: 'manual',
  duration: 100,
  animTimingFunction: Vivus.EASE,
  onReady: function (reasonFiveStage1) {
    // `el` property is the SVG element
    // myVivus.el.setAttribute('height', 'auto');
    
  }
});


let reasonSixStage1 = new Vivus('reasonSix-stage1', {
  file: '/img/fullpage/reasonSix.svg',
  type: 'delayed',
  start: 'manual',
  duration: 100,
  animTimingFunction: Vivus.EASE,
  onReady: function (reasonSixStage1) {
    // `el` property is the SVG element
    // myVivus.el.setAttribute('height', 'auto');
    
  }
});


let reasonSevenStage1 = new Vivus('reasonSeven-stage1', {
  file: '/img/fullpage/reasonSeven-puzzle.svg',
  type: 'delayed',
  start: 'manual',
  duration: 100,
  animTimingFunction: Vivus.EASE,
  onReady: function (reasonSevenStage1) {
    // `el` property is the SVG element
    // myVivus.el.setAttribute('height', 'auto');
    
  }
});

let reasonSevenStage2 = new Vivus('reasonSeven-stage2', {
  file: '/img/fullpage/reasonSeven-hand.svg',
  type: 'delayed',
  start: 'manual',
  duration: 100,
  animTimingFunction: Vivus.EASE,
  onReady: function (reasonSevenStage2) {
    // `el` property is the SVG element
    // myVivus.el.setAttribute('height', 'auto');
    
  }
});





var starsLoop = null;


new fullpage('#fullpage', {
	//options here
	licenseKey: '92F995AF-7B314C2B-B62BC370-71221CB0',
	navigation: true,
	anchors:['executive-coaching', 'best-executive-coaches', 'engagement-management', 'our-customers', 'coach-supervision', 'real-time-reporting', 'coaching-app', 'seamless-integration', 'help'],
	sectionsColor: ['#034298', '#563a56', '#f5f5f6', '#527334', '#0077be', '#C5E1E8', '#2A3B4D', '#FEFCEE', '#FEFCEE'],
	// navigationTooltips: ['Home', 'Best Coaches', 'Engagement Management', 'Our Customers', 'Coach Supervision', 'Real-Time Reporting', 'Coaching App', 'Seamless Integration', 'Contact Us'],


	onLeave: function(origin, destination, direction){
		var leavingSection = this;

		// if(destination.index == 0) {
		// 	$('#fp-nav').addClass('hidden')
		// } else {
		// 	$('#fp-nav').removeClass('hidden')
		// }


		$('#fullpage .active .reveal1').removeClass('animated');
		$('#fullpage .active .reveal2').removeClass('animated');
		$('#fullpage .active .reveal3').removeClass('animated');

		


		
		$('#home-lady').removeClass('animated');
		$('#home-clouds').removeClass('animated');
		// $('#curtain').removeClass('animated');
		$('#reasonOne-stage1').removeClass('animated');
		$('.star').removeClass('animated');
		clearInterval(starsLoop);
		$('#reasonTwo-stage1').removeClass('animated');
		$('#reasonFour-stage1').removeClass('animated');
		$('.water').removeClass('animated');
		$('#reasonFive-stage1').removeClass('animated');
		$('#reasonSix-stage1').removeClass('animated');
		$('.barchart').removeClass('animated');
		$('.barchart').removeClass('animated2');
		$('#reasonSeven-stage1').removeClass('animated');
		$('#reasonSeven-stage2').removeClass('animated');
		$('.hand-red').removeClass('animated');





		setTimeout(function(){

		reasonOneStage1.setFrameProgress(0);
		reasonTwoStage1.setFrameProgress(0);
		reasonFourStage1.setFrameProgress(0);
		reasonFiveStage1.setFrameProgress(0);
		reasonSixStage1.setFrameProgress(0);
		reasonSevenStage1.setFrameProgress(0);
		reasonSevenStage2.setFrameProgress(0);

		
		

		if(destination.index == 2 || destination.index == 5  || destination.index == 7 || destination.index == 8 || destination.index == 9){
			$('#fp-nav').addClass('dark');
			$('#top-nav').removeClass('light');
			$('#hamburger').removeClass('light');
			$('#logo-light').addClass('opacity-0');
			$('#logo-dark').removeClass('opacity-0');
		} else {
			$('#fp-nav').removeClass('dark');
			$('#top-nav').addClass('light');
			$('#hamburger').addClass('light');
			$('#logo-light').removeClass('opacity-0');
			$('#logo-dark').addClass('opacity-0');
		}

    if(destination.index == 9) {
      $('#help-slide').fadeOut(300);
    } else {
      $('#help-slide').fadeIn(300);
    }

		}, 200);
	},

	afterLoad: function(section, origin, destination, direction) {
		$('#fullpage .active .reveal1').addClass('animated');
		$('#fullpage .active .reveal2').addClass('animated');
		$('#fullpage .active .reveal3').addClass('animated');

		if(origin.index == 0) {
			$('#home-clouds').addClass('animated');
			setTimeout(function(){
				$("#home-lady").addClass('animated');
			}, 500);
		}

    


		if(origin.index == 1) {
			$('#reasonOne-stage1').addClass('animated');
			reasonOneStage1.play();

			var count = 1;

			setTimeout(function(){
				$('.star').each(function(count){
				  count++;
				  var row = $('.star'+count);
				  setTimeout(function() {
				    row.addClass('animated');
				  }, 100*count);
				})
			}, 1000);

			starsLoop = setInterval(function(){
				$('.star').removeClass('animated');
				setTimeout(function(){
					$('.star').each(function(count){
					  count++;
					  var row = $('.star'+count);
					  setTimeout(function() {
					    row.addClass('animated');
					  }, 100*count);
					})
				}, 1000);
			}, 5000);




		} else if(origin.index == 2) {
			$('#reasonTwo-stage1').addClass('animated');
			reasonTwoStage1.play();

		} else if(origin.index == 3) {
			// $('#curtain').addClass('animated');

		} else if(origin.index == 4) {
			$('#reasonFour-stage1').addClass('animated');
			
			setTimeout(function(){
				$('.water').addClass('animated');
			}, 1000);
			
			reasonFourStage1.play();

		} else if(origin.index == 5) {
			$('#reasonFive-stage1').addClass('animated');
			reasonFiveStage1.play();

		} else if(origin.index == 6) {
			$('#reasonSix-stage1').addClass('animated');
			reasonSixStage1.play();

			setTimeout(function(){
				$('.barchart').addClass('animated');
			}, 500);

			setTimeout(function(){
				$('.barchart').addClass('animated2');
			}, 1500);


		} else if(origin.index == 7) {
			$('#reasonSeven-stage1').addClass('animated');
			reasonSevenStage1.play();
			reasonSevenStage2.play();
			
			setTimeout(function(){
				$('#reasonSeven-stage2').addClass('animated');
				$('.hand-red').addClass('animated');
				reasonSevenStage2.play();
			}, 2000);
		}




	}

});

//methods
// fullpage_api.setAllowScrolling(false);

$('.click-down').on('click', function (e) {
	fullpage_api.moveSectionDown();
});

$('.logo').on('click', function (e) {
	fullpage_api.moveTo(1);
});








// WEBPACK FOOTER //
// ./assets/js/index.js